import { lazy } from 'react';

export const Admin = lazy(function factory() {
  return import('./Admin');
});

export const Root = lazy(function factory() {
  return import('./Root');
});
